/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ActivityState } from "./ActivityState";
import {
  ActivityStateFromJSON,
  ActivityStateFromJSONTyped,
  ActivityStateToJSON,
  ActivityStateToJSONTyped,
} from "./ActivityState";
import type { ActivityRole } from "./ActivityRole";
import {
  ActivityRoleFromJSON,
  ActivityRoleFromJSONTyped,
  ActivityRoleToJSON,
  ActivityRoleToJSONTyped,
} from "./ActivityRole";
import type { ActivityType } from "./ActivityType";
import {
  ActivityTypeFromJSON,
  ActivityTypeFromJSONTyped,
  ActivityTypeToJSON,
  ActivityTypeToJSONTyped,
} from "./ActivityType";
import type { ActivityComment } from "./ActivityComment";
import {
  ActivityCommentFromJSON,
  ActivityCommentFromJSONTyped,
  ActivityCommentToJSON,
  ActivityCommentToJSONTyped,
} from "./ActivityComment";

/**
 *
 * @export
 * @interface ActivityReadModel
 */
export interface ActivityReadModel {
  /**
   *
   * @type {string}
   * @memberof ActivityReadModel
   */
  activityId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ActivityReadModel
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof ActivityReadModel
   */
  createdBy?: string;
  /**
   *
   * @type {ActivityState}
   * @memberof ActivityReadModel
   */
  state?: ActivityState;
  /**
   *
   * @type {ActivityType}
   * @memberof ActivityReadModel
   */
  type?: ActivityType;
  /**
   *
   * @type {string}
   * @memberof ActivityReadModel
   */
  owner?: string;
  /**
   *
   * @type {ActivityRole}
   * @memberof ActivityReadModel
   */
  trigger?: ActivityRole;
  /**
   *
   * @type {ActivityRole}
   * @memberof ActivityReadModel
   */
  target?: ActivityRole;
  /**
   *
   * @type {string}
   * @memberof ActivityReadModel
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof ActivityReadModel
   */
  details?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ActivityReadModel
   */
  associatedDocuments: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ActivityReadModel
   */
  frontIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ActivityReadModel
   */
  metadata?: string;
  /**
   *
   * @type {string}
   * @memberof ActivityReadModel
   */
  parentActivityId?: string;
  /**
   *
   * @type {string}
   * @memberof ActivityReadModel
   */
  nextActivityId?: string;
  /**
   *
   * @type {Array<ActivityReadModel>}
   * @memberof ActivityReadModel
   */
  subActivities: Array<ActivityReadModel>;
  /**
   *
   * @type {Array<ActivityComment>}
   * @memberof ActivityReadModel
   */
  comments: Array<ActivityComment>;
  /**
   *
   * @type {boolean}
   * @memberof ActivityReadModel
   */
  isInProgress?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ActivityReadModel
   */
  isCompleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ActivityReadModel
   */
  isWaiting?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ActivityReadModel
   */
  isActionRequired?: boolean;
}

/**
 * Check if a given object implements the ActivityReadModel interface.
 */
export function instanceOfActivityReadModel(
  value: object,
): value is ActivityReadModel {
  if (
    !("associatedDocuments" in value) ||
    value["associatedDocuments"] === undefined
  )
    return false;
  if (!("frontIds" in value) || value["frontIds"] === undefined) return false;
  if (!("subActivities" in value) || value["subActivities"] === undefined)
    return false;
  if (!("comments" in value) || value["comments"] === undefined) return false;
  return true;
}

export function ActivityReadModelFromJSON(json: any): ActivityReadModel {
  return ActivityReadModelFromJSONTyped(json, false);
}

export function ActivityReadModelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActivityReadModel {
  if (json == null) {
    return json;
  }
  return {
    activityId: json["activityId"] == null ? undefined : json["activityId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    state:
      json["state"] == null ? undefined : ActivityStateFromJSON(json["state"]),
    type: json["type"] == null ? undefined : ActivityTypeFromJSON(json["type"]),
    owner: json["owner"] == null ? undefined : json["owner"],
    trigger:
      json["trigger"] == null
        ? undefined
        : ActivityRoleFromJSON(json["trigger"]),
    target:
      json["target"] == null ? undefined : ActivityRoleFromJSON(json["target"]),
    title: json["title"] == null ? undefined : json["title"],
    details: json["details"] == null ? undefined : json["details"],
    associatedDocuments: json["associatedDocuments"],
    frontIds: json["frontIds"],
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    parentActivityId:
      json["parentActivityId"] == null ? undefined : json["parentActivityId"],
    nextActivityId:
      json["nextActivityId"] == null ? undefined : json["nextActivityId"],
    subActivities: (json["subActivities"] as Array<any>).map(
      ActivityReadModelFromJSON,
    ),
    comments: (json["comments"] as Array<any>).map(ActivityCommentFromJSON),
    isInProgress:
      json["isInProgress"] == null ? undefined : json["isInProgress"],
    isCompleted: json["isCompleted"] == null ? undefined : json["isCompleted"],
    isWaiting: json["isWaiting"] == null ? undefined : json["isWaiting"],
    isActionRequired:
      json["isActionRequired"] == null ? undefined : json["isActionRequired"],
  };
}

export function ActivityReadModelToJSON(json: any): ActivityReadModel {
  return ActivityReadModelToJSONTyped(json, false);
}

export function ActivityReadModelToJSONTyped(
  value?: ActivityReadModel | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    activityId: value["activityId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    state: ActivityStateToJSON(value["state"]),
    type: ActivityTypeToJSON(value["type"]),
    owner: value["owner"],
    trigger: ActivityRoleToJSON(value["trigger"]),
    target: ActivityRoleToJSON(value["target"]),
    title: value["title"],
    details: value["details"],
    associatedDocuments: value["associatedDocuments"],
    frontIds: value["frontIds"],
    metadata: value["metadata"],
    parentActivityId: value["parentActivityId"],
    nextActivityId: value["nextActivityId"],
    subActivities: (value["subActivities"] as Array<any>).map(
      ActivityReadModelToJSON,
    ),
    comments: (value["comments"] as Array<any>).map(ActivityCommentToJSON),
    isInProgress: value["isInProgress"],
    isCompleted: value["isCompleted"],
    isWaiting: value["isWaiting"],
    isActionRequired: value["isActionRequired"],
  };
}
